/* eslint-disable @typescript-eslint/no-explicit-any */
export enum ACTION {
  UPDATE = 'UPDATE',
  EDIT = 'EDIT',
}

export enum PaginateSpread {
  SPREAD = '...',
  PREV = '.../PREV',
  NEXT = '.../NEXT',
}

export type PaginateValue = number | PaginateSpread
export interface InitialProps {
  collection?: PaginateValue[]
  next?: boolean
  last?: boolean
  prev?: boolean
  first?: boolean
  current: number
}

export interface ActionProps {
  type: ACTION
  payload: InitialProps
}

export const initial = (state: InitialProps): InitialProps => ({
  collection: [],
  next: false,
  last: false,
  prev: false,
  first: false,
  ...state,
})

export const reducer = (
  _state: InitialProps,
  action: ActionProps,
): InitialProps => {
  switch (action.type) {
    case ACTION.UPDATE:
      return action.payload

    default:
      return action.payload
  }
}

export const DOT = PaginateSpread.SPREAD
export const DOT_PREV = PaginateSpread.PREV
export const DOT_NEXT = PaginateSpread.NEXT

// helper
export const assign = <T>(prevState: T, nextState: T): T => {
  return {
    ...prevState,
    ...nextState,
  }
}

export const range = (start: number, end: number, step = 1): number[] => {
  const len = Math.floor((end - start) / step) + 1

  return Array(len)
    .fill(0)
    .map((_, idx) => start + idx * step)
}

export const next = (curr: number, max: number): boolean => {
  return curr + 1 <= max
}

export const prev = (curr: number, min: number): boolean => {
  return curr - 1 >= min
}

export const first = (curr: number, min: number): boolean => {
  return curr >= min && prev(curr, min)
}

export const last = (curr: number, max: number): boolean => {
  return curr <= max && next(curr, max)
}

export const withPattern =
  (group: number, curr: number, min: number, max: number) =>
  (
    cb: (group: number, curr: number, min: number, max: number) => void,
  ): any => {
    return cb(group, curr, min, max)
  }

export const calculateJumpNumber = (
  action: string,
  currentPage: number,
  limit: number,
): number => {
  if (action === DOT_PREV) {
    return currentPage - limit
  }

  if (action === DOT_NEXT) {
    return currentPage + limit
  }

  return currentPage
}
